import React from 'react';
import PropTypes from 'prop-types';

const InputRadioButtons = ({ name, list, keyField, displayField, disabled, itemDisabled, onChange, defaultValue, horizontal }) => {   

    //Tekið upp frá Magna, lausn sem hann gerði í IHK.
    let id = "radio_" + name + new Date().getTime() + Math.floor(Math.random() * 100);

    const handleChange = e => {
        // console.log(e.target.value); 
        if (onChange){
            onChange(e.target.value);
        }
      };

      //console.log("List", list);
      if (list == undefined || list == null || list.error != undefined){
          return null;
      }

    return (
        <div className={ horizontal ? 'checkradio-group inline' : 'checkradio-group' }>
            {list.map((item, index) => {        
                return (                
                <div className="ci-radio" key={index}>
                    <input
                    id={id+`_`+item[keyField]}
                    type="radio"
                    name={name}
                    value={item[keyField]}
                    onChange={handleChange}
                    checked={defaultValue == item[keyField]}
                    disabled={disabled || (typeof itemDisabled === 'function' ? (itemDisabled(item)) : (itemDisabled))}
                    />
                    <label htmlFor={id+`_`+item[keyField]}>{item[displayField]}</label>
                </div>
            );
            })}
            </div>           
      );
};

InputRadioButtons.propTypes = {      
   name: PropTypes.string,
   list: PropTypes.oneOfType([PropTypes.array,  PropTypes.oneOf([null]), PropTypes.object]),
   keyField : PropTypes.string,
   displayField : PropTypes.string,
   onDisplayItem : PropTypes.func,    
   disabled : PropTypes.bool,
   itemDisabled : PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
   onChange : PropTypes.func,
   defaultValue : PropTypes.any,
   horizontal : PropTypes.bool

};

export default InputRadioButtons;
